import * as moment from 'moment';

export class Utility {

	public static readonly months = ['Jänner', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
	public static readonly weekdays = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];

	public static toggleClass(element: Element, className: string, add: boolean) {

		let found = false;

		for(const elClass of element.classList) {
			if(elClass === className) {
				found = true;
				break;
			}
		}

		if(found == add) {
			return;
		}

		if(add) {
			element.classList.add(className);
		}
		else {
			element.classList.remove(className);
		}
	}

	public static getDateUtcKey(date: Date): string {
		return `${date.getUTCFullYear()}-${Utility.padNumber2(date.getUTCMonth() + 1)}-${Utility.padNumber2(date.getUTCDate())}`;
	}

	public static getUtcDateFromUnspecified(dateString: string): Date {
		const date = moment(dateString).toDate();
		
		return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
	}

	public static getTime(date: Date): string {
		return `${Utility.padNumber2(date.getHours())}:${Utility.padNumber2(date.getMinutes())}`
	}

	public static padNumber2(number: number): string {
		if(number < 10) {
			return "0" + number;
		}
		else {
			return number.toString();
		}
	}

	public static upperOrEqualBound<T>(array: T[], search: T) : T | null {
		let lower = 0;
		let upper = array.length;

		while(lower < upper) {
			const index = (upper + lower) >> 1;
			if(!(search <= array[index])) {
				lower = index + 1;
			}
			else {
				upper = index;
			}
		}

		if(lower == array.length) {
			return null;
		}

		return array[lower];
	}

	public static delay(milliseconds: number): Promise<number | void> {
		return new Promise<number | void>(resolve => {
			setTimeout(() => {
				resolve();
			}, milliseconds);
		});
	}
}